import { motion, AnimatePresence } from 'motion/react';
import React from 'react';

interface NameInputProps {
  show: boolean;
  children: React.ReactNode;
}

export const NameInput: React.FC<NameInputProps> = ({ show, children }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          style={{
            position: 'absolute',
            top: '50%',
            left: '16px',
            right: '16px',
            transform: 'translateY(-50%)',
            zIndex: 10,
          }}
          initial={{ opacity: 0, y: 100, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -50, scale: 0.9 }}
          transition={{
            duration: 0.3,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
